// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jw-popover[data-v-2f25ec2e]{position:absolute;background:#060d17;border-radius:4px}", ""]);
// Exports
module.exports = exports;
